export const parseDateFromAPIFormat = (i18n, date) => {
  if (date == null) {
    return null;
  }
  if (typeof date === 'string') {
    const dateFromMdyyyyFormat = i18n.parseDate(date.substring(0, 10), { raw: 'M/d/yyyy' });
    const dateFromyyyyMdFormat = i18n.parseDate(date.substring(0, 10), { raw: 'yyyy-M-d' });
    return dateFromMdyyyyFormat || dateFromyyyyMdFormat;
  }
  return date;
};

export const formatDateToAPIFormat = (i18n, date) => {
  if (date == null) {
    return '';
  }

  if (typeof date === 'string') {
    return date;
  }
  return i18n.formatDate(date, {
    raw: 'M/d/yyyy',
  });
};
